// src/store/slices/cmsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

export const loadCMSData = createAsyncThunk(
  "cms/loadCMSData",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await agent.get(`${API.CMS_PAGE}${slug}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load CMS page"
      );
    }
  }
);

const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    cmsData: {},
    loading: false,
    error: null,
  },
  reducers: {
    clearCMS(state) {
      state.cmsData = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCMSData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadCMSData.fulfilled, (state, action) => {
        state.loading = false;
        state.cmsData = action.payload;
      })
      .addCase(loadCMSData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCMS } = cmsSlice.actions;
export default cmsSlice.reducer;
